import axios, { type AxiosRequestConfig, type Canceler } from 'axios'
import { getRequestKey } from '../common/useDebounceRequest'

const cancelerMap = new Map<string, Canceler>()

export class AxiosCancel {
    private static instance?: AxiosCancel

    static createInstance() {
        return this.instance ?? (this.instance = new AxiosCancel())
    }
    add(config: AxiosRequestConfig) {
        const r = getRequestKey(config)
        const url = config.url!
        this.remove(r)
        config.cancelToken = new axios.CancelToken((cancel) => {
            if (!cancelerMap.has(r)) {
                cancelerMap.set(r, cancel)
            }
        })
    }
    remove(url: string) {
        if (cancelerMap.has(url)) {
            const cancel = cancelerMap.get(url)
            cancel && cancel(url)
            cancelerMap.delete(url)
        }
    }
}

const axiosCancel = AxiosCancel.createInstance()

export default axiosCancel
